import { Store } from './store';
import type { FilterType } from '../utils/filters';

export interface AppState {
  gridSubdivisions: 4 | 8 | 16;
  strobeInterval: number;
  markerSize: number;
  lastImageId: string | null;
  isLocked: boolean;
  strobeEnabled: boolean;
}

export interface ImageState {
  currentImage: {
    id: string;
    blob: Blob;
    name: string;
  } | null;
  opacity: number;
  filter: FilterType;
  offset: { x: number; y: number; z: number };
  scale: number;
  gridEnabled: boolean;
  flipH: boolean;
  flipV: boolean;
}

export function createAppState(): AppState {
  return {
    gridSubdivisions: 4,
    strobeInterval: 500,
    markerSize: 1,
    lastImageId: null,
    isLocked: false,
    strobeEnabled: false,
  };
}

export function createImageState(): ImageState {
  return {
    currentImage: null,
    opacity: 0.5,
    filter: 'none',
    offset: { x: 0, y: 0, z: 0 },
    scale: 1,
    gridEnabled: false,
    flipH: false,
    flipV: false,
  };
}

export const appStore = new Store<AppState>(createAppState());
export const imageStore = new Store<ImageState>(createImageState());
